var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2998_44)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C12.2926 2.5 14.1561 4.35843 14.1561 6.65097C14.1561 8.94869 12.2943 10.8071 10 10.8071C7.70744 10.8071 5.84392 8.94864 5.84392 6.65097C5.84392 4.35838 7.70577 2.5 10 2.5ZM20.3766 4.77198C22.6691 4.77198 24.5275 6.63041 24.5275 8.92808C24.5275 10.3421 23.8154 11.5981 22.7309 12.3463C22.1509 12.3995 21.5709 12.4218 20.9874 12.4218C19.8549 12.4218 18.7258 12.2502 17.6138 12.0306C16.7575 11.2704 16.2204 10.1584 16.2204 8.92978C16.2204 6.63206 18.0788 4.77367 20.3765 4.77367L20.3766 4.77198ZM16.1072 17.6384V25.1407H25.1746V18.3883C25.1746 18.1687 25.3411 17.9885 25.5607 17.9713C25.7803 17.9576 25.9743 18.112 26.0051 18.3317L26.9403 25.084C26.9455 25.1063 26.9455 25.1235 26.9455 25.1407H29.3925L28.1896 16.451C28.1192 15.9328 27.9837 15.4317 27.7949 14.9667C27.601 15.2704 27.3247 15.5295 26.9815 15.7183C24.284 17.0499 20.4624 17.6779 17.4664 17.6779C17.0134 17.6779 16.5621 17.6642 16.1091 17.6384L16.1072 17.6384ZM14.5353 16.6191V25.1405H5.46788V18.3882C5.46788 18.1685 5.30143 17.9883 5.08178 17.9712C4.86214 17.9575 4.66823 18.1119 4.64249 18.3315L3.70214 25.0839C3.70214 25.1062 3.69699 25.1234 3.69699 25.1405H1.25L2.45292 16.4509C2.78753 14.0571 4.42973 12.058 6.84584 12.058H12.6322C14.8029 12.058 17.8247 13.2969 20.9876 13.2969C22.5114 13.2969 23.9871 13.1339 25.3858 12.8319C27.1344 12.4492 27.8242 14.2596 26.5629 14.9442C23.9323 16.118 20.8073 16.7975 17.4647 16.7975C16.4626 16.7975 15.4828 16.7358 14.5338 16.6174L14.5353 16.6191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2998_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestFriend);
export default __webpack_public_path__ + "static/media/bestFriend.11b121f3e47fe4c008ccbadd49a7ec5b.svg";
export { ForwardRef as ReactComponent };